import { render, staticRenderFns } from "./tablaModulo.vue?vue&type=template&id=662805a0&scoped=true&"
import script from "./tablaModulo.vue?vue&type=script&lang=js&"
export * from "./tablaModulo.vue?vue&type=script&lang=js&"
import style0 from "./tablaModulo.vue?vue&type=style&index=0&id=662805a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662805a0",
  null
  
)

export default component.exports